import Component from 'components/pages/Gaming/Gaming.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('gaming');
export default buildPage(Component, {
  skipSSR: true,
  requiresAuthentication: false,
  metaData: {
    title: 'Gaming Offers',
    description:
      'Earn cashback on games and enjoy your wallet being a little bigger at the end of the month.',
  },
});
